<template>
  <div>
    <h1>Usuarios</h1>
    <div style="display: flex; gap: 1rem; margin-bottom: 1.5rem; align-items: flex-end; flex-wrap: wrap;">
      <div style="display: flex; gap: 0.5rem; align-items: flex-end;">
        <div>
          <label style="font-weight: 600;">Nombre</label>
          <input v-model="nombre" placeholder="Buscar por nombre" @keyup.enter="fetchUsuarios" 
                 style="padding: 0.4rem; border-radius: 4px; width: 200px;" />
        </div>
        <button @click="fetchUsuarios" style="background: #007bff; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">🔍</button>
      </div>
      <button v-if="puedeAgregar" @click="abrirModalAgregar" style="background: #6c757d; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">+ Agregar Usuario</button>
    </div>
    <div v-if="puedeMostrar" class="tabla-responsive">
      <table class="tabla-usuarios-principal">
      <thead>
        <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
          <th style="padding: 1rem;">Id</th>
          <th style="padding: 1rem;">Nombre</th>
          <th style="padding: 1rem;">Correo</th>
          <th style="padding: 1rem;">Username</th>
          <th style="padding: 1rem;">Teléfono</th>
          <th style="padding: 1rem;">Rol</th>
          <th style="padding: 1rem;">Fecha Registro</th>
          <th style="padding: 1rem; text-align:center;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuario in usuarios" :key="usuario.Id" style="border-bottom: 1px solid #e9ecef;">
          <td style="padding: 0.8rem; font-weight: 600;">{{ usuario.Id }}</td>
          <td style="padding: 0.8rem;">{{ usuario.Nombre }}</td>
          <td style="padding: 0.8rem;">{{ usuario.Correo }}</td>
          <td style="padding: 0.8rem; font-weight: 600; color: #007bff;">{{ usuario.Username }}</td>
          <td style="padding: 0.8rem;">{{ usuario.Telefono }}</td>
          <td style="padding: 0.8rem;">{{ usuario.RolDescripcion }}</td>
          <td style="padding: 0.8rem;">{{ formatFecha(usuario.FechaRegistro) }}</td>
          <td style="padding: 0.8rem; text-align:center;">
            <button v-if="puedeModificar" @click="abrirModalEditar(usuario)" style="background: #ffc107; color: #333; border: none; padding: 0.4rem 1rem; border-radius: 4px; margin-right: 0.5rem;">Editar</button>
            <button v-if="puedeEliminar" @click="eliminarUsuario(usuario.Id)" style="background: #dc3545; color: white; border: none; padding: 0.4rem 1rem; border-radius: 4px;">Eliminar</button>
          </td>
        </tr>
        <tr v-if="usuarios.length === 0">
          <td colspan="8" style="text-align:center; padding: 2rem; color: #6c757d; font-style: italic;">No hay usuarios registrados</td>
        </tr>
      </tbody>
      </table>
    </div>
    <div v-if="!puedeMostrar" style="text-align:center; color:#d32f2f; margin:2rem 0;">No tienes permiso para ver la lista de usuarios.</div>
    <div style="margin-top:1rem;">
      <button :disabled="page === 1" @click="cambiarPagina(page-1)">Anterior</button>
      Página {{ page }} de {{ totalPages }}
      <button :disabled="page === totalPages" @click="cambiarPagina(page+1)">Siguiente</button>
    </div>

    <!-- Modales -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Editar Usuario</h3>
          <button class="close-btn" @click="cerrarModalEditar">&times;</button>
        </div>
        <label>Nombre
          <input v-model="usuarioEditar.Nombre" />
        </label>
        <label>Correo
          <input v-model="usuarioEditar.Correo" />
        </label>
        <label>Username
          <input v-model="usuarioEditar.Username" />
        </label>
        <label>Teléfono
          <input v-model="usuarioEditar.Telefono" />
        </label>
        <label>Rol
          <select v-model="usuarioEditar.IdRol">
            <option v-for="rol in roles" :key="rol.Id" :value="rol.Id">{{ rol.Descripcion }}</option>
          </select>
        </label>
        <label>Contraseña (dejar vacío para no cambiar)
          <input v-model="usuarioEditar.Contrasena" type="password" />
        </label>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarEdicion">Guardar</button>
          <button class="btn-secondary" @click="cerrarModalEditar">Cancelar</button>
        </div>
      </div>
    </div>
    <div v-if="showModalAgregar" class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Agregar Usuario</h3>
          <button class="close-btn" @click="cerrarModalAgregar">&times;</button>
        </div>
        <label>Nombre
          <input v-model="usuarioNuevo.Nombre" />
        </label>
        <label>Correo
          <input v-model="usuarioNuevo.Correo" />
        </label>
        <label>Username
          <input v-model="usuarioNuevo.Username" />
        </label>
        <label>Teléfono
          <input v-model="usuarioNuevo.Telefono" />
        </label>
        <label>Rol
          <select v-model="usuarioNuevo.IdRol">
            <option v-for="rol in roles" :key="rol.Id" :value="rol.Id">{{ rol.Descripcion }}</option>
          </select>
        </label>
        <label>Contraseña
          <input v-model="usuarioNuevo.Contrasena" type="password" />
        </label>
        <div class="modal-buttons">
          <button class="btn-primary" @click="guardarNuevo">Agregar</button>
          <button class="btn-secondary" @click="cerrarModalAgregar">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'UsuariosView',
  data() {
    // Leer permisos de localStorage
    let permisosUsuarios = [];
    try {
      const permisos = JSON.parse(localStorage.getItem('permisos') || '{}');
      permisosUsuarios = permisos['/usuarios'] || [];
    } catch (e) {}
    return {
      usuarios: [],
      total: 0,
      page: 1,
      pageSize: 20,
      nombre: '',
      loading: false,
      showModal: false,
      showModalAgregar: false,
      usuarioEditar: null,
      usuarioNuevo: {
        Nombre: '',
        Correo: '',
        Username: '',
        Telefono: '',
        Contrasena: '',
        IdRol: ''
      },
      roles: [],
      permisosUsuarios
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    puedeMostrar() {
      return this.permisosUsuarios.some(p => p.Descripcion === 'Mostrar Lista Usuarios');
    },
    puedeAgregar() {
      return this.permisosUsuarios.some(p => p.Descripcion === 'Agregar Usuarios');
    },
    puedeModificar() {
      return this.permisosUsuarios.some(p => p.Descripcion === 'Modificar Usuarios');
    },
    puedeEliminar() {
      return this.permisosUsuarios.some(p => p.Descripcion === 'Eliminar Usuarios');
    }
  },
  methods: {
    async guardarEdicion() {
      if (!this.usuarioEditar) return;
      try {
        const response = await apiFetch(`/usuarios/ModificarUsuario/${this.usuarioEditar.Id}`, {
          method: 'PATCH',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            Nombre: this.usuarioEditar.Nombre,
            Correo: this.usuarioEditar.Correo,
            Username: this.usuarioEditar.Username,
            Telefono: this.usuarioEditar.Telefono,
            IdRol: Number(this.usuarioEditar.IdRol),
            Contrasena: this.usuarioEditar.Contrasena
          })
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error al editar usuario');
        }
        
        const data = await response.json();
        this.cerrarModalEditar();
        this.fetchUsuarios();
        if (this.$toast) this.$toast.success(data.message || 'Usuario editado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error(err.message || 'Error al editar usuario');
      }
    },
    cerrarModalEditar() {
      this.showModal = false;
      this.usuarioEditar = null;
    },
    abrirModalEditar(usuario) {
      this.usuarioEditar = { ...usuario, Contrasena: '' };
      this.showModal = true;
      this.fetchRoles();
    },
    async fetchRoles() {
      try {
        const response = await apiFetch('/roles/ObtenerListaRoles', {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        this.roles = await response.json();
      } catch (err) {
        this.roles = [];
        if (this.$toast) this.$toast.error('Error al obtener roles');
      }
    },
    async fetchUsuarios() {
      this.loading = true;
      try {
        const params = `?page=${this.page}&pageSize=${this.pageSize}&nombre=${encodeURIComponent(this.nombre)}`;
        const response = await apiFetch(`/usuarios/ObtenerUsuariosPaginado${params}`, {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await response.json();
        this.usuarios = data.usuarios || [];
        this.total = data.total || 0;
      } catch (err) {
        this.usuarios = [];
        this.total = 0;
        if (this.$toast) this.$toast.error('Error al obtener usuarios');
      }
      this.loading = false;
    },
    async eliminarUsuario(id) {
      if (confirm('¿Seguro que deseas eliminar este usuario?')) {
        try {
          const response = await apiFetch(`/usuarios/EliminarUsuario/${id}`, {
            method: 'DELETE',
            headers: {
              'accept': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error al eliminar usuario');
          }
          
          const data = await response.json();
          this.fetchUsuarios();
          if (this.$toast) this.$toast.success(data.message || 'Usuario eliminado correctamente');
        } catch (err) {
          if (this.$toast) this.$toast.error(err.message || 'Error al eliminar usuario');
        }
      }
    },
    abrirModalAgregar() {
      this.usuarioNuevo = { Nombre: '', Correo: '', Username: '', Telefono: '', Contrasena: '', IdRol: '' };
      this.showModalAgregar = true;
      this.fetchRoles();
    },
    cerrarModalAgregar() {
      this.showModalAgregar = false;
    },
    async guardarNuevo() {
      try {
        const response = await apiFetch('/usuarios/AgregarUsuario', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            Nombre: this.usuarioNuevo.Nombre,
            Correo: this.usuarioNuevo.Correo,
            Username: this.usuarioNuevo.Username,
            Telefono: this.usuarioNuevo.Telefono,
            Contrasena: this.usuarioNuevo.Contrasena,
            IdRol: Number(this.usuarioNuevo.IdRol)
          })
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error al agregar usuario');
        }
        
        const data = await response.json();
        this.cerrarModalAgregar();
        this.fetchUsuarios();
        if (this.$toast) this.$toast.success(data.message || 'Usuario agregado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error(err.message || 'Error al agregar usuario');
      }
    },
    cambiarPagina(nuevaPagina) {
      this.page = nuevaPagina;
      this.fetchUsuarios();
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      // Para fechas que incluyen hora, mantenemos el comportamiento original
      // ya que probablemente necesitamos mostrar la hora también
      return new Date(fecha).toLocaleString();
    }
  },
  mounted() {
    this.fetchUsuarios();
    // Configurar scroll horizontal
    this.$nextTick(() => {
      const tabla = document.querySelector('.tabla-responsive');
      if (tabla) {
        tabla.addEventListener('wheel', (e) => { if (tabla.scrollWidth > tabla.clientWidth) { e.preventDefault(); tabla.scrollLeft += e.deltaY; } }, { passive: false });
        let isDown = false, startX, scrollLeft;
        tabla.addEventListener('mousedown', (e) => { isDown = true; startX = e.pageX - tabla.offsetLeft; scrollLeft = tabla.scrollLeft; tabla.style.cursor = 'grabbing'; });
        tabla.addEventListener('mouseleave', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mouseup', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mousemove', (e) => { if (!isDown) return; e.preventDefault(); const x = e.pageX - tabla.offsetLeft; tabla.scrollLeft = scrollLeft - (x - startX) * 2; });
      }
    });
  },
  watch: {
    showModalAgregar(val) {
      if (!val) this.usuarioNuevo = { Nombre: '', Correo: '', Username: '', Telefono: '', Contrasena: '', IdRol: '' };
    },
    showModal(val) {
      if (!val) this.usuarioEditar = null;
    }
              // permisosUsuarios: [] // Removed invalid comment
  }
};
</script>

<style scoped>
/* --- TABLA RESPONSIVA --- */
.tabla-responsive {
  width: 100% !important; overflow-x: auto !important; overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch; margin-bottom: 1.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px; max-width: 100vw !important; display: block !important; position: relative;
  scrollbar-width: auto; scrollbar-color: #4a90e2 #e0e0e0; cursor: grab;
}
.tabla-responsive:active { cursor: grabbing; }
.tabla-responsive::-webkit-scrollbar { height: 12px; }
.tabla-responsive::-webkit-scrollbar-track { background: #e0e0e0; border-radius: 6px; }
.tabla-responsive::-webkit-scrollbar-thumb { background: #4a90e2; border-radius: 6px; }
.tabla-responsive::after { content: "← Desplázate horizontalmente →"; position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); font-size: 12px; color: #666; opacity: 0.7; }
@media (min-width: 1201px) { .tabla-responsive::after { display: none; } }
.tabla-usuarios-principal { width: 1000px !important; min-width: 1000px !important; table-layout: fixed !important; }
.modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 320px;
  max-width: 90vw;
}
.modal-content label {
  display: block;
  margin-top: 1rem;
}
.modal-content input, .modal-content select {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-content button {
  margin-top: 1.2rem;
}

/* Estilos para tabla responsive */
.tabla-responsive {
  width: 100%;
  overflow-x: auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 1rem;
}

.tabla-usuarios-principal {
  width: 100%;
  min-width: 1400px; /* Ancho mínimo para evitar compresión */
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.9rem;
  table-layout: fixed;
}

.tabla-usuarios-principal th {
  white-space: nowrap;
  font-weight: 600;
  text-align: left;
  border-right: 1px solid rgba(255,255,255,0.2);
}

.tabla-usuarios-principal th:last-child {
  border-right: none;
}

.tabla-usuarios-principal td {
  white-space: nowrap;
  vertical-align: middle;
  border-right: 1px solid #f1f3f4;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Anchos específicos para cada columna */
.tabla-usuarios-principal th:nth-child(1),
.tabla-usuarios-principal td:nth-child(1) { width: 60px; } /* Id */

.tabla-usuarios-principal th:nth-child(2),
.tabla-usuarios-principal td:nth-child(2) { width: 200px; } /* Nombre */

.tabla-usuarios-principal th:nth-child(3),
.tabla-usuarios-principal td:nth-child(3) { width: 220px; } /* Correo */

.tabla-usuarios-principal th:nth-child(4),
.tabla-usuarios-principal td:nth-child(4) { width: 180px; } /* Username */

.tabla-usuarios-principal th:nth-child(5),
.tabla-usuarios-principal td:nth-child(5) { width: 120px; } /* Teléfono */

.tabla-usuarios-principal th:nth-child(6),
.tabla-usuarios-principal td:nth-child(6) { width: 120px; } /* Rol */

.tabla-usuarios-principal th:nth-child(7),
.tabla-usuarios-principal td:nth-child(7) { width: 140px; } /* Fecha */

.tabla-usuarios-principal th:nth-child(8),
.tabla-usuarios-principal td:nth-child(8) { width: 200px; } /* Acciones */

/* Estilos específicos para mejorar legibilidad */
.tabla-usuarios-principal td:nth-child(2) {
  font-weight: 600;
  color: #2c3e50;
}

.tabla-usuarios-principal td:nth-child(3) {
  color: #666;
  font-size: 0.85rem;
}

.tabla-usuarios-principal td:nth-child(6) {
  font-weight: 500;
  color: #28a745;
}

/* Mejorar botones de acciones */
.tabla-usuarios-principal button {
  font-size: 0.8rem;
  padding: 0.3rem 0.8rem !important;
  margin: 0 0.2rem;
  border-radius: 4px;
  font-weight: 500;
}

/* Padding uniforme para todas las celdas */
.tabla-usuarios-principal th,
.tabla-usuarios-principal td {
  padding: 0.8rem 0.5rem !important;
}

.tabla-usuarios-principal td:last-child {
  border-right: none;
}

.tabla-usuarios-principal tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

/* Scroll horizontal más visible */
.tabla-responsive::-webkit-scrollbar {
  height: 8px;
}

.tabla-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.tabla-responsive::-webkit-scrollbar-thumb {
  background: #007bff;
  border-radius: 4px;
}

.tabla-responsive::-webkit-scrollbar-thumb:hover {
  background: #0056b3;
}

/* Estilos para el header del modal */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e1e5e9;
  padding-bottom: 1rem;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
}

/* Botón de cerrar (X) */
.close-btn {
  background: none;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

/* Responsivo para el botón de cerrar */
@media (max-width: 768px) {
  .close-btn {
    width: 20px;
    height: 20px;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .close-btn {
    width: 18px;
    height: 18px;
    font-size: 0.9rem;
  }
}

.close-btn:hover {
  background-color: #f5f5f5;
  color: #666;
}

.close-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
}

/* Container para botones del modal */
.modal-buttons {
  display: flex;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid #e1e5e9;
  background-color: #f8f9fa;
  margin-top: 1.5rem;
  justify-content: flex-end;
}

/* Botones estandarizados */
.btn-primary {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 0.9rem;
}

.btn-primary:hover {
  background: #5a6268;
}

.btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.3);
}

.btn-secondary {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
  padding: 0.5rem 1.2rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.btn-secondary:hover {
  background: #dee2e6;
  border-color: #adb5bd;
}

.btn-secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(108, 117, 125, 0.15);
}
</style>

